module.exports = __webpack_public_path__ + "static/media/sp_lingxian.d8214e5a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/product/sp_lingxian.svg
// module id = 229
// module chunks = 0